import api from "api/axios";

const BASE = "/admin/dental-workspace-masters/diagnosis";

export const dentalDiagnosisMasterApi = {
  list: (params) => api.get(BASE, { params }),
  create: (payload) => api.post(BASE, payload),
  update: (id, payload) => api.patch(`${BASE}/${id}`, payload),
  remove: (id) => api.delete(`${BASE}/${id}`),
  /** The server parses and validates the sheet; the reply is its import report. */
  importFile: (file) => {
    const body = new FormData();
    body.append("file", file);
    return api.post(`${BASE}/import`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  /** `kind` is "template" or "export"; the response is the xlsx as a Blob. */
  downloadFile: (kind, params) =>
    api.get(`${BASE}/${kind}`, { params, responseType: "blob" }),
};
